import { IHistoryTagsParams } from "./models/TagChartModel";
import { IStringToTimeValueListDictionary } from "./models/TagsModels";
import { TagSelectionDto } from "../app/TagQueryModels";
import { parseExplicitDeviceTagName } from "../app/TagQueryUtils";

export const validateResponse = (
  response: IStringToTimeValueListDictionary,
  params: IHistoryTagsParams,
  intervalInSeconds: number
) => {
  const numberOfExpectedDataPoints = Math.floor(
    params.range.end.diff(params.range.start, "seconds") / intervalInSeconds + 60
  );

  const series = Object.values(response);
  if (series.length > 0 && series[0].length > numberOfExpectedDataPoints) {
    console.error(
      "recieved too many values per tag " + series[0].length + " > " + numberOfExpectedDataPoints
    );
  }

  const expectedTagNames = getExpectedTagNames(params.selections);
  const allDevicesLogicalTagNames = new Set(
    params.selections
      .filter((selection) => selection.type === "allDevices")
      .map((selection) => selection.logicalTagName)
  );
  const responseTagNames = Object.keys(response);
  if (allDevicesLogicalTagNames.size === 0 && responseTagNames.length > expectedTagNames.size) {
    throw new Error(
      "number of tags in response are greater than number of tags in request res=" +
        responseTagNames.length +
        " : " +
        expectedTagNames.size
    );
  } else if (responseTagNames.length < expectedTagNames.size) {
    console.warn(
      "number of tags in response are less than number of tags in request res=" +
        responseTagNames.length +
        " : " +
        expectedTagNames.size
    );
  }
  responseTagNames.forEach((tagName: string) => {
    const explicitIdentity = parseExplicitDeviceTagName(tagName);
    const isExpectedAllDevicesSeries =
      explicitIdentity !== undefined && allDevicesLogicalTagNames.has(explicitIdentity.logicalTagName);
    if (!expectedTagNames.has(tagName) && !isExpectedAllDevicesSeries) {
      throw new Error(
        "recieved unexpected tag " +
          tagName +
          "\n " +
          JSON.stringify(responseTagNames) +
          "\nTags:" +
          JSON.stringify(Array.from(expectedTagNames))
      );
    }
  });
};

function getExpectedTagNames(selections: TagSelectionDto[]): Set<string> {
  const tagNames = new Set<string>();
  for (const selection of selections) {
    if (selection.type === "scalar") {
      tagNames.add(selection.logicalTagName);
    } else if (selection.type === "specificDevices") {
      selection.deviceIds.forEach((deviceId) => tagNames.add(`${selection.logicalTagName}:${deviceId}`));
    }
  }
  return tagNames;
}
